import { useState } from "react";
import { DrawingType } from "../../config";
import doodleIcon from "../../assets/doodle-icon.svg";
import colorIcon from "../../assets/color-icon.svg";
import "./DisplayPopUp.scss";

interface DisplayPopUpProps {
  onContinue: (mode: DrawingType) => void;
  onClose: () => void;
}

function DisplayPopUp({ onContinue, onClose }: DisplayPopUpProps) {
  const [selected, setSelected] = useState<DrawingType>("doodle");

  return (
    <div className="dp__overlay" onClick={onClose}>
      <div className="dp__card" onClick={(e) => e.stopPropagation()}>
        <h2 className="dp__title">How would you like to doodle?</h2>

        <div className="dp__choices">
          <button
            type="button"
            className={`dp__choice${selected === "doodle" ? " dp__choice--active" : ""}`}
            onClick={() => setSelected("doodle")}
            aria-label="Doodle"
          >
            <img src={doodleIcon} alt="Doodle" className="dp__choice-img" />
          </button>

          <button
            type="button"
            className={`dp__choice${selected === "color" ? " dp__choice--active" : ""}`}
            onClick={() => setSelected("color")}
            aria-label="Color"
          >
            <img src={colorIcon} alt="Color" className="dp__choice-img" />
          </button>
        </div>

        <button
          type="button"
          className="dp__continue"
          onClick={() => onContinue(selected)}
        >
          Okay!
        </button>
      </div>
    </div>
  );
}

export default DisplayPopUp;
